var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var StackLayoutImplementation = function (_a) {
    var className = _a.className, customStyle = _a.customStyle, children = _a.children, onPress = _a.onPress, onContextMenu = _a.onContextMenu, onMouseMove = _a.onMouseMove, onMouseLeave = _a.onMouseLeave, backgroundImageUri = _a.backgroundImageUri, backgroundImageResizeMode = _a.backgroundImageResizeMode, ref = _a.ref, testId = _a.testId, testParameters = _a.testParameters, id = _a.id;
    return (React.createElement("div", { id: id, ref: ref, style: __assign({ backgroundImage: backgroundImageUri ? "url(" + backgroundImageUri + ")" : backgroundImageUri, backgroundSize: backgroundImageResizeMode }, customStyle), role: onPress ? 'button' : undefined, onClick: onPress, onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, onContextMenu: onContextMenu, className: className, "data-testid": testId, "data-testparameters": JSON.stringify(testParameters) }, children));
};
export default StackLayoutImplementation;
//# sourceMappingURL=StackLayoutImplementation.js.map